export enum StatutInfo {

    A_VERIFIER = 'A_VERIFIER',

    FRANCE_CONNECT = 'FRANCE_CONNECT',

    VALIDER = 'VALIDER',

    REJETER = 'REJETER',
}
